// extracted by mini-css-extract-plugin
export default {"container":"UnifiedSplashPage-module__container--4rk-9","button":"UnifiedSplashPage-module__button--qMnwI","imageContainer":"UnifiedSplashPage-module__imageContainer--4szgb"};